import { FileClient } from "clients/rest";

export type B100113ExcelRequest = Partial<{
  shodaibunFrom: string;
  shodaibunTo: string;
  shochubunFrom: string;
  shochubunTo: string;
  shoshobunFrom: string;
  shoshobunTo: string;
  shohinCdFrom: string;
  shohinCdTo: string;
  janCdFrom: string;
  janCdTo: string;
}>;

export const B100113GetExcel = (props: B100113ExcelRequest) => {
  return FileClient.get("b100113/get/excel", {
    params: props,
  });
};
